// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1UNzg","boxTitle":"Qualiphy_boxTitle__2XeT0","box":"Qualiphy_box__1QrkK","toggleWrap":"Qualiphy_toggleWrap__VDEto"};